const style = document.createElement("style");
style.innerHTML = `
  @media (min-width: 768px) {
    .basic-info-container {
      display: grid;
      align-items: start;
      gap: 1rem;
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
`;
document.head.appendChild(style);

// url參數
let scriptId = document.getElementById("fundBasicInfoScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "IV16";

function getCurrentDate() {
  const now = new Date();
  const latestDate = `${now.getFullYear()}/${String(
    now.getMonth() + 1
  ).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")}`;
  const updateDate = document.getElementById("basic-info-latest-date");
  updateDate.textContent = `${latestDate} 更新`;
}

function loadScript() {
  const targetElement = document.getElementById("fundBasicInfoScript");

  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}`;
  fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .then((data) => {
      //建立基本資料區域
      const basicInfo = document.createElement("div");
      //建立基本資料
      const info = [
        {
          label: "ISIN CODE",
          value: data.isinCode,
        },
        {
          label: `基金類別`,
          value: data.investmentTarget,
        },
        {
          label: "基金類組-區域",
          value: data.investmentArea,
        },
        {
          label: "基金類組-產業",
          value: data.fundNameCategory,
        },
        {
          label: "計價幣別",
          value: data.currency,
        },
        {
          label: "風險等級",
          value: data.riskLevel ? `RR${data.riskLevel}` : "--",
        },
        {
          label: "配息頻率",
          value: data.dividendFrequency,
        },
      ];
      //建立第二基本資料
      const otherInfo = [
        {
          label: "基金種類",
          value: "主動式交易基金(申購免證券交易稅)",
        },
        {
          label: `境內/外`,
          value: data.fundArea,
        },
        {
          label: "註冊地",
          value: data.registration,
        },
        {
          label: "指標指數",
          value: data.benchMark,
        },
        {
          label: "成立日期",
          value: data.establishmentDate,
        },
        {
          label: "基金規模",
          value: data.fundScale
            ? `${data.fundScale.toLocaleString()} 千 ${
                data.fundScaleCurrency
              } (${data.fundScaleDate.slice(0, 7)})`
            : "--",
        },
      ];

      //建立基本資料樣式
      let infoHTML = info
        .map(
          (item, index) => `
            <div style="display: flex; justify-content: space-between; align-items: center; ${
              index === info.length - 1
                ? ""
                : "border-bottom: 1px solid #E5E5E5;"
            } padding: 8px 16px; color: #666666; font-size: 16px;">
                <div style="white-space: nowrap; margin-right: 4px;">${
                  item.label
                }</div>
                <div style="word-break: break-all">${item.value}</div>
            </div>`
        )
        .join("");

      // 修改 otherInfoHTML 的生成
      let otherInfoHTML = otherInfo
        .map((item, index) => {
          const borderStyle =
            index === otherInfo.length - 1
              ? ""
              : "border-bottom: 1px solid #E5E5E5;";

          return `
            <div style="display: flex; justify-content: space-between; align-items: center; ${borderStyle} padding: 8px 16px; color: #666666; ; font-size: 16px;">
                <div style="white-space: nowrap; margin-right: 4px;">${item.label}</div>
                <div style="word-break: break-all">${item.value}</div>
            </div>
          `;
        })
        .join("");

      //渲染基本資料
      basicInfo.innerHTML = `
        <div>
            <div style="color: #333333; font-weight: 500; font-size: 18px; line-height: 1.75rem; margin-bottom: 0.75rem;">
                基本資料
                <span id="basic-info-latest-date" style="font-size: 14px; color: #999999"></span>
            </div>
            <div style="font-weight: 500; font-size: 16px;">
                <div style="color: #333333;">
                ${data.fundShortName}${
                    data.warningWarning
                      ? `<span style="font-weight: bold">(${data.warningWarning})</span>`
                      : ""
                  }
                </div>
                <div style="color: #999999;">${data.fundEnglishShortName}</div>
            </div>

            <div class="basic-info-container">
                <div style="border: 1px solid #E5E5E5; border-radius: 4px; margin-top: 1rem; width: 100%;">
                    ${infoHTML} 
                </div>

                <div style="border: 1px solid #E5E5E5; border-radius: 4px; margin-top: 1rem; width: 100%;">
                    ${otherInfoHTML} 
                </div>
            </div>
            <div style="font-size: 14px; margin-top: 16px; background: #f5f5f5; padding: 16px; border-radius: 4px;">資料來源：好好證券彙整，詳見重要聲明。</div>
        </div>
    `;

      targetElement.innerHTML = "";
      targetElement.appendChild(basicInfo);
      getCurrentDate();
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}

loadScript();
